// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
/* eslint-disable */
const awsExportsDev = {
  'aws_project_region': 'ap-northeast-1',
  'aws_appsync_graphqlEndpoint': 'https://tleqaa2ggvczbg6s2prbcpswpi.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  'aws_appsync_region': 'ap-northeast-1',
  'aws_appsync_authenticationType': 'AMAZON_COGNITO_USER_POOLS',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:31e62fe8-cf0f-4ce7-ad76-0094f8e13a2e',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_JnT13l30U',
  'aws_user_pools_web_client_id': '3gckjc9r2abrha48gvob9mnccc',
  'oauth': {},
  'Auth': {
    storage: window.sessionStorage,
  },
  Storage: {
    AWSS3: {
      bucket: 'nskenpo-backend-dev-nskenpobackend-private5ed30f02-3agyhbtw4z4w',
      region: 'ap-northeast-1'
    }
  }
}

const awsExportsMobileAppDev = {
  ...awsExportsDev,
  'aws_user_pools_web_client_id': '7b9415t6hn14h4pqbhgu1dhh5b'
}

const awsExportsStg = {
  'aws_project_region': 'ap-northeast-1',
  'aws_appsync_graphqlEndpoint': 'https://r5pz53z7ynbojgo54c2xrvbudq.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  'aws_appsync_region': 'ap-northeast-1',
  'aws_appsync_authenticationType': 'AMAZON_COGNITO_USER_POOLS',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:0a8a6e87-223e-4c79-a08f-15e77c1244ae',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_rPbjQ1ayT',
  'aws_user_pools_web_client_id': '3rc769mprhpfvpc3hvuiprbva4',
  'oauth': {},
  'Auth': {
    storage: window.sessionStorage,
  },
  Storage: {
    AWSS3: {
      bucket: 'nskenpo-backend-stg-nskenpobackend-private5ed30f02-lw7y7mdsxhhh',
      region: 'ap-northeast-1'
    }
  }
}

const awsExportsMobileAppStg = {
  ...awsExportsStg,
  'aws_user_pools_web_client_id': '2pv9ogqhuknjtfjfag9q8dte87'
}

const awsExportsProd = {
  'aws_project_region': 'ap-northeast-1',
  'aws_appsync_graphqlEndpoint': 'https://u4b3q7anbjekxor6x2e46ewtca.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  'aws_appsync_region': 'ap-northeast-1',
  'aws_appsync_authenticationType': 'AMAZON_COGNITO_USER_POOLS',
  'aws_cognito_identity_pool_id': 'ap-northeast-1:e235ae65-52d6-4abf-be96-9fee7cba5f29',
  'aws_cognito_region': 'ap-northeast-1',
  'aws_user_pools_id': 'ap-northeast-1_cGwD7KYYD',
  'aws_user_pools_web_client_id': '2jroof4adluaok1j9gu882469p',
  'oauth': {},
  'Auth': {
    storage: window.sessionStorage,
  },
  Storage: {
    AWSS3: {
      bucket: 'nskenpo-backend-prod-nskenpobacken-private5ed30f02-zjn68rodroaa',
      region: 'ap-northeast-1'
    }
  }
}

const awsExportsMobileAppProd = {
  ...awsExportsProd,
  'aws_user_pools_web_client_id': '7ute7tfrl4s5e4v6o8eko9amvv'
}

export {
  awsExportsDev,
  awsExportsStg,
  awsExportsProd,
  awsExportsMobileAppDev,
  awsExportsMobileAppStg,
  awsExportsMobileAppProd
}
